import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import Products from 'merchandise-lib/constants/Product';
import UIUAFeatureTable from 'ui-addon-upgrades/featureTable/FeatureTable';
import FeatureTableColTag from '../../../components/feature-table/FeatureTableColTag';
import { useShowStarterCustomerPlatformUpsellCard } from '../../../hooks/upsell/useStarterUpsell';
import { SingleSkeletonLoader } from '../../components/SingleSkeletonLoader';
import { FeatureTableHeaderCellContent } from '../../components/feature-table/FeatureTableHeaderCellContent';
import { PriceByProductApiName } from '../../containers/PriceByProductApiName';
import { PurchaseMotionsByProductApiNameAndLocation } from '../../containers/PurchaseMotionsByProductApiNameAndLocation';
import { useBadges } from '../../hooks/badges/useBadges';
import { useFormattedFeatureTableBodyData } from '../../hooks/features/useFormattedFeatureTableBodyData';
import { createFeatureTableHeaderTrackingData } from '../../utils/trackingData';
import { jsx as _jsx } from "react/jsx-runtime";
export const MarketingHubFeatureTable = () => {
  var _badges$starterApiNam, _badges$Products$MARK, _badges$Products$MARK2;
  const {
    showStarterCustomerPlatformUpsellCard,
    upsellStarterApiName,
    loading
  } = useShowStarterCustomerPlatformUpsellCard();
  const starterApiNameForBadges = showStarterCustomerPlatformUpsellCard ? upsellStarterApiName : Products.MARKETING_HUB_STARTER;
  const badgeApiNames = [starterApiNameForBadges, Products.MARKETING_HUB_PROFESSIONAL, Products.MARKETING_HUB_ENTERPRISE];
  const {
    badges
  } = useBadges({
    productApiNames: badgeApiNames,
    skipOverride: loading
  });
  const formattedFeatureTableBodyData = useFormattedFeatureTableBodyData({
    productApiNames: [Products.MARKETING_HUB_STARTER, Products.MARKETING_HUB_PROFESSIONAL, Products.MARKETING_HUB_ENTERPRISE],
    skuCategoryName: 'MARKETING_PRODUCTS'
  });
  if (formattedFeatureTableBodyData.error) {
    return null;
  }
  if (formattedFeatureTableBodyData.loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 250,
      width: "100%"
    });
  }

  // If the fetch for data is successful and there are no features
  // don't render the table because the purchase motions are identical
  // to that of the merch card
  if (formattedFeatureTableBodyData.data.sectionData.all.features.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIUAFeatureTable, {
    canViewNewSeats: true,
    headerData: {
      [Products.MARKETING_HUB_STARTER]: {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          Badge: /*#__PURE__*/_jsx(FeatureTableColTag, {
            apiName: Products.MARKETING_HUB_STARTER,
            badgeName: badges === null || badges === void 0 || (_badges$starterApiNam = badges[starterApiNameForBadges]) === null || _badges$starterApiNam === void 0 ? void 0 : _badges$starterApiNam.badgeName
          }),
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.starterCard"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: Products.MARKETING_HUB_STARTER
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
            productApiName: showStarterCustomerPlatformUpsellCard ? upsellStarterApiName : Products.MARKETING_HUB_STARTER,
            location: "MERCH_CARD",
            displayCount: 1,
            trackingData: createFeatureTableHeaderTrackingData(showStarterCustomerPlatformUpsellCard ? upsellStarterApiName : Products.MARKETING_HUB_STARTER, 'marketing')
          })
        })
      },
      [Products.MARKETING_HUB_PROFESSIONAL]: {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          Badge: /*#__PURE__*/_jsx(FeatureTableColTag, {
            apiName: Products.MARKETING_HUB_PROFESSIONAL,
            badgeName: badges === null || badges === void 0 || (_badges$Products$MARK = badges[Products.MARKETING_HUB_PROFESSIONAL]) === null || _badges$Products$MARK === void 0 ? void 0 : _badges$Products$MARK.badgeName
          }),
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.professionalCard"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: Products.MARKETING_HUB_PROFESSIONAL
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
            productApiName: Products.MARKETING_HUB_PROFESSIONAL,
            location: "MERCH_CARD",
            displayCount: 1,
            trackingData: createFeatureTableHeaderTrackingData(Products.MARKETING_HUB_PROFESSIONAL, 'marketing')
          })
        })
      },
      [Products.MARKETING_HUB_ENTERPRISE]: {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          Badge: /*#__PURE__*/_jsx(FeatureTableColTag, {
            apiName: Products.MARKETING_HUB_ENTERPRISE,
            badgeName: badges === null || badges === void 0 || (_badges$Products$MARK2 = badges[Products.MARKETING_HUB_ENTERPRISE]) === null || _badges$Products$MARK2 === void 0 ? void 0 : _badges$Products$MARK2.badgeName
          }),
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.enterpriseCard"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: Products.MARKETING_HUB_ENTERPRISE
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
            productApiName: Products.MARKETING_HUB_ENTERPRISE,
            location: "MERCH_CARD",
            displayCount: 1,
            trackingData: createFeatureTableHeaderTrackingData(Products.MARKETING_HUB_ENTERPRISE, 'marketing')
          })
        })
      }
    },
    bodyData: formattedFeatureTableBodyData.data,
    isInbound25PricingPage: true
  });
};